export default "__VITE_ASSET__DtfU2p8G__"